import { render } from "./GalerieMiniSegment.vue?vue&type=template&id=07948f89"
import script from "./GalerieMiniSegment.vue?vue&type=script&lang=js"
export * from "./GalerieMiniSegment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__